import { useEffect, useRef, useState } from "react";
import { Button, Card } from "react-bootstrap";
import {
  DataTable,
  GridButton,
  PageHeader,
  InputTypeConstants,
  SearchParamTypeConstants,
  getSearchField,
  getTableHeader,
  Loading,
} from "wup-module1-base";
import { PageTitleConstants, RoutePathConstants } from "../../../Constants";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import {
  faPencil,
  faCircleCheck,
  faCircleXmark,
  faTrash,
  faObjectGroup,
  faUsersBetweenLines,
  faComments,
  faPlus,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function QuestionList() {
  const navigate = useNavigate();
  const questionsRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [pageName, setPageName] = useState(null);
  // const [pageId, setPageId] = useState(null);
  // const [searchParams, setSearchParams] = useSearchParams();
  const { pageId } = useParams();

  // useEffect(() => {
  //   setIsLoading(true);
  //   const param = searchParams.get("pageId");
  //   if (param) setPageId(param);
  //   else setPageId(null);
  //   setIsLoading(false);
  // }, [searchParams]);

  useEffect(() => {
    setIsLoading(true);
    if (!!pageId) {
      setPageName(
        JSON.parse(sessionStorage.getItem("pages"))?.find(
          (i) => i.id === pageId
        )?.name
      );
    }
    setIsLoading(false);
  }, [pageId]);

  function getActionButtons(value) {
    return (
      <>
        {/* {!!pageId && (
          <GridButton
            id={"btnPage" + value.id}
            color={!!value.pageId ? "btn-danger" : "btn-success"}
            icon={!!value.pageId ? faMinus : faPlus}
            disabled={value.deleted}
            ariaLabel={
              !!value.pageId
                ? "Usunięcie pytania ze strony"
                : "Dodanie pytania do strony"
            }
            title={!!value.pageId ? "Usuń ze strony" : "Dodaj do strony"}
            onClick={() => handlePageBtn(value)}
          />
        )} */}
        <GridButton
          id={"btnEdit" + value.id}
          color="btn-primary"
          icon={faPencil}
          disabled={value.deleted}
          ariaLabel="Edycja pytania"
          title="Edycja pytania"
          onClick={() => navigate(`${RoutePathConstants.Edit}/${value.id}`)}
        />
      </>
    );
  }

  function fetchQuestions() {
    if (!!pageId)
      return JSON.parse(sessionStorage.getItem("questions"))?.filter(
        (i) => i.pageId === pageId
      );
    else return JSON.parse(sessionStorage.getItem("questions"));
  }

  const handlePageBtn = (value) => {
    value.pageId = value.pageId ? null : pageId;
    const questions = JSON.parse(sessionStorage.getItem("questions"));
    const updated = questions.map((item) =>
      item.id === value.id ? value : item
    );
    sessionStorage.setItem("questions", JSON.stringify(updated));
    questionsRef?.current?.reload();
  };

  const renderRelated = (value) => {
    return value.relatedQuestions?.length > 0 ? (
      <FontAwesomeIcon
        icon={faCircleCheck}
        title="Tak"
        className="text-success"
        size="xl"
      />
    ) : (
      <FontAwesomeIcon
        icon={faCircleXmark}
        className="text-danger"
        title="Nie"
        size="xl"
      />
    );
  };

  const searchFields = [
    getSearchField(
      SearchParamTypeConstants.SEARCH_STRING,
      "name",
      "Nazwa",
      InputTypeConstants.string
    ),
    getSearchField(
      SearchParamTypeConstants.SEARCH_STRING,
      "description",
      "Opis",
      InputTypeConstants.string
    ),
    getSearchField(
      SearchParamTypeConstants.SEARCH_EQUAL,
      "deleted",
      "Pokaż usunięte",
      InputTypeConstants.checkbox
    ),
  ];

  const tableHeaders = [
    getTableHeader("Nazwa", "name", null, true, "w-15"),
    getTableHeader("Opis", "description", null, true, "w-auto"),
    getTableHeader(
      "Czy zawiera skorelowane",
      null,
      null,
      false,
      "w-15",
      renderRelated,
      "text-center"
    ),
    getTableHeader(
      null,
      null,
      "Akcje",
      false,
      "w-10",
      getActionButtons,
      "text-center"
    ),
  ];

  const getRowProps = (value) => ({
    className: value.deleted ? "row-deleted" : "",
  });

  return (
    <>
      <PageHeader
        content={PageTitleConstants.QuestionList}
        additionalContent={pageName ?? null}
      />
      <Card>
        <Card.Body className="pt-4-5">
          {isLoading ? (
            <Loading />
          ) : (
            <DataTable
              fetchData={fetchQuestions}
              headers={tableHeaders}
              searchFields={searchFields}
              rowProps={getRowProps}
              ref={questionsRef}
            >
              <Button
                variant="primary"
                onClick={() => navigate(`${RoutePathConstants.Add}`)}
              >
                Dodaj pytanie
              </Button>
            </DataTable>
          )}
        </Card.Body>
      </Card>
    </>
  );
}

export default QuestionList;
